"use client";
import { ButtonBase } from "@mui/material";

import ToolTip from "../Tooltip";
import { _Icon } from "./index";

const ButtonText = ({
  selected,
  IconStart,
  IconEnd,
  tooltip,
  label = "",
  size = "medium",
  disabled = false,
  sx = {},
  ...props
}) => (
  <ToolTip title={tooltip}>
    <ButtonBase
      disabled={disabled}
      sx={theme => ({
        px: 3,
        borderRadius: theme.shape.round,
        height: size === "small" ? 32 : 40,
        bgcolor: disabled
          ? theme.palette.alpha(theme.palette.surface.on.color, 0.12)
          : undefined,
        transition: theme.transitions.create("all"),
        typography: {
          compact: "labelMd",
          expanded: `label${size === "small" ? "Md" : "Lg"}`
        },
        color: disabled
          ? theme.palette.alpha(theme.palette.surface.on.color, 0.38)
          : "primary.color",
        "&:hover": {
          backgroundImage: `linear-gradient(${theme.palette.alpha(
            theme.palette.secondary.on.container,
            0.08
          )}, ${theme.palette.alpha(
            theme.palette.secondary.on.container,
            0.08
          )})`
        },
        ...sx
      })}
      {...props}
    >
      {IconStart ? (
        <_Icon color="primary" Icon={IconStart} disabled={disabled} />
      ) : null}
      {label}
      {IconEnd ? (
        <_Icon end color="primary" Icon={IconEnd} disabled={disabled} />
      ) : null}
    </ButtonBase>
  </ToolTip>
);

export default ButtonText;
